import { AllInsightsViewer } from "../../components/discovery/insights/AllInsightsViewer";
import { UnifiedFilters } from "../../components/discovery/unifiedFilters/UnifiedFilter";

import { DiscoveryBody } from "./DiscoveryBody";

export const AllInsights: React.FunctionComponent = () => {
    return (
        <DiscoveryBody data-testid="discovery-body">
            <UnifiedFilters />
            <AllInsightsViewer />
        </DiscoveryBody>
    );
};
